import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { defaultLocale, localeOptions } from '@/constants/config'
const locale = localStorage.getItem('locale')
  && localeOptions.filter(x => x.id === localStorage.getItem('locale'))
    .length > 0
  ? localStorage.getItem('locale')
  : defaultLocale
function loadLocaleMessages(locale) {
  let locales = {};
  if (locale == 'ar') {
    locales = require.context('@/locales/ar', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  } else if (locale == 'en') {
    locales = require.context('@/locales/en', true, /[A-Za-z0-9-_,\s]+\.json$/i)

  }

  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

Vue.use(VueI18n)
let messages = {};
messages[locale] = loadLocaleMessages(locale)
// console.log(messages);

export default new VueI18n({
  locale,
  messages,
})